// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zskj","largestCol":"styles_largestCol__1hxCz","smallestCol":"styles_smallestCol__1LVvw"};